// extracted by mini-css-extract-plugin
module.exports = {"section":"depts_side_nav_section__1Z8Eb","div":"depts_side_nav_div__3Xouc"};